// s/** @format */

import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { useKeycloak } from "@react-keycloak/ssr";
import { useCookies } from "react-cookie";
import { logger } from "@goldenbird1/ui-logger-library";
import { Form, Input, Select, Row, Col, Button, message, Upload,Checkbox } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import { PlusOutlined,WhatsAppOutlined } from "@ant-design/icons";
import moment from "moment";
import { countryList } from "../../utils/getCountries";
import categories from "../../public/filestore/categories.json";
import { useRouter } from "next/router";
import { formSubmit, formView, formFallout, apiError } from "../../utils/GTMDataLayer";
import { generateRandomString } from "../../utils/generateRandomString";
// import { Seller_RFQ_submitted } from "../../utils/moEngageEvents";
import { v4 as uuidv4 } from "uuid";

const { Option } = Select;

const SellerContact = (props) => {
  const recaptchaRef = React.createRef();
  function onChange(value) {
    // console.log("Captcha value:", value);
  }
  const router = useRouter();
  const mediaMatch = window.matchMedia("(min-width: 768px)");
  const [form] = Form.useForm();
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [cookie, setCookie] = useCookies(["utm_source"]);
  const [whatsApp,setWhatsApp] = useState(props?.initialValues?.whatsappConsent === 'Yes' || props?.initialValues?.whatsappConsent=='true' ? true : false);
  const [whatsAppNumber,setWhatsAppNumber] = useState(props?.initialValues?.whatsappNumber)
  const [selectedOption, setSelectedOption] = useState([]);
  const [selectedOther, setSelectedOther] = useState([])
  const [productCategories, setProductCategories] = useState([])
  const [selectedProductOption, setSelectedProductOption] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  let retryCount = 0;

  // const currentUser = useSelector(state => state.auth.currentUser);
  const { keycloak } = useKeycloak();
  // console.log(keycloak.subject);

  const acceptedFileTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.ms-excel",
    "application/vnd.ms-powerpoint",
    "image/jpeg",
    "image/png",
  ];

  const typeOfCategories = categories.map((v, i) => {
    return (
      <Option key={i} value={v.key}>
        {v.value}
      </Option>
    );
  });

  // const normFile = e => {
  //     // console.log('Upload event:', e);

  //     if (Array.isArray(e)) {
  //         return e;
  //     }

  //     return e;
  // };

  // const getBase64 = (file) => {
  //     return new Promise((resolve, reject) => {
  //         const reader = new FileReader();
  //         reader.readAsDataURL(file);
  //         reader.onload = () => resolve(reader.result);
  //         reader.onerror = error => reject(error);
  //     });
  // }

  useEffect(() => {
    if(localStorage.getItem('kcTokenSaved')){
      setIsAuthenticated(true);
    }
  }, []);

  useEffect(() => {
    try {
      formView("seller query rfq", "");
    } catch (err) {
      console.warn("datalayer form view error: " + err);
    }
  }, []);

  useEffect(() => {
    let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/master_data/v1/product-type"
    fetch(url,{
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          'trace-id' : uuidv4()
        },
      }
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw (
            res.statusText || "Oops something went wrong. Please try again!"
          );
        }
      })
      .then((res) => {
        setProductCategories(res?.filter((value, index, self) => index === self.findIndex((t) => ( t.name === value.name))))
      })
      .catch((err) => {
        console.log(err.message || err, 5);
      });
}, []);

  const feildnameArray = [],
    gtmFormFunction = (feildname) => {
      try {
        if (!feildnameArray.includes(feildname)) {
          formFallout(feildname, "seller query rfq", "");
          feildnameArray.push(feildname);
        }
      } catch (err) {
        console.warn("datalayer form view error: " + err);
      }
    };

  const beforeUpload = (file) => {
    const isJpgOrPng = acceptedFileTypes.includes(file.type);
    if (!isJpgOrPng) {
      message.error(
        "You can only upload JPG/PNG, PDF, MS-Excel & MS-PPT file!",
        5
      );
      return false;
    }
    const isLt2M = file.size <= 2 * 1024 * 1024;
    if (!isLt2M) {
      message.error("File size must smaller than 2MB!", 5);
      return false;
    }
    return isJpgOrPng && isLt2M;
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  const handleChange = (info) => {
    if (
      info.file.status === "done" ||
      info.file.status === "removed" ||
      info.file.status === "uploading"
    ) {
      let { fileList = [] } = info || {};
      let uploadedList = [];
      for (let file of fileList) {
        const isJpgOrPng = acceptedFileTypes.includes(file.type);
        const isLt2M = file.size <= 2 * 1024 * 1024;
        if (isJpgOrPng && isLt2M) {
          uploadedList.push(file);
        }
      }
      setFileList(uploadedList);
      return;
    }
  };

  const sellerRFQCall = (data) => {
    let buyerId = props.initialValues && props.initialValues?.profileId ? props.initialValues.profileId : null;
    fetch(process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/home/forms/v3/queries", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
        'trace-id' : uuidv4()
      },
    })
      .then((res) => {
        if (res.ok) {
          // message.success('Your query has been sent successfully.', 5);
          props.sendQueryCancel("success");
          formSubmit("seller query rfq", "");
        } else {
          apiError('sellerRFQCall', res.statusText, 'POST', 'SellerContact.js');
          setErrors(
            errors.concat({
              atStage: "Error while sending",
              message: res.statusText,
            })
          );
          throw res;
        }
        setLoading(false);
      })
      .catch((err) => {
        logger("error", "Error from SPLP RFQ" +err?.statusText + ' data:' + JSON.stringify(data)+': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
        apiError('sellerRFQCall', err, 'POST', 'SellerContact.js');
        if(err.status === 401){
          router.push('/signin');
        } else {
          if (retryCount < 3) {
            sellerRFQCall(data);
          } else {
            message.error(res.statusText, 5);
            // message.error(err.message, 5);
            setErrors(errors.concat(err));
            setLoading(false);
          }
          retryCount++;
        }
      });
  };

  const updateWhatsappNumber = e => {
    let {value = ""} = e.target || {}
    value !== null && setWhatsAppNumber(value)
  }

  const onFinish = (values) => {
    // Seller_RFQ_submitted({Form_submitted:true, pagetype:"sellerpage"})
    if(selectedOption?.includes("other")){
      values.customizationRequirements = [selectedOther];
    }

    let isAnonymousUser = true;
    if (props.initialValues && props.initialValues.profileId) {
      isAnonymousUser = false;
    } else {
      const recaptchaValue = recaptchaRef.current.getValue();
      if (!recaptchaValue) {
        console.log("Invalid Recaptcha");
        return;
      }
    }

    let { sellerDetails = {} } = props;
    let { vanityId = "" } = sellerDetails || {};

    let data = {
      profileId:
        (props.initialValues && props.initialValues.profileId) || "anonymous",
      profileType: props.initialValues && props.initialValues.profileType,
      isAnonymousUser: isAnonymousUser,
      queryCategory: values.category,
      questions: values.requirementDetails,
      productCategoryComment: values.productCategory,
      customizationRequirmentsComment: values.customizationRequirements,
      quantityRequired: values.quantity,
      targetUnitPrice: values.pricePerItem,
      targetDeliveryDate: values.deliveryDate,
      requesterName: values.requesterName,
      companyName: values.companyName,
      emailId: values.emailId,
      country: values.destinationCountry,
      mobileNo: values.mobileNo,
      zipcode: values.zipcode,
      destinationCountry: values.destinationCountry,
      scpURL:
        process.env.NEXT_PUBLIC_URL +
        "/seller-profile/" +
        props?.sellerDetails?.id.split("::")[2],
      vanityId: vanityId,
      rfqType: "SELLER",
      sellerId: props?.sellerDetails?.id.split("::")[2],
      buyerId: props.userId && props.userId.split("::")[1],
      sellerBrandName: props.sellerDetails && props.sellerDetails.brandName,
      aboutCompany: values.aboutCompany,
      deliverylocationType: values.deliverylocationType,
      preferedCurrency: values.preferedCurrency,
      consent : whatsApp ? "Yes" : "No",
      communicationNumber : whatsAppNumber
    };

    /* read and pass utm source from cookie  */
    if (cookie.utm_source) {
      let cookieVal = cookie.utm_source;

      data.utm = cookieVal.utm_source;
      data.utmCampaign = cookieVal.utm_campaign;
      data.utmMedium = cookieVal.utm_medium;
      data.utmTerm = cookieVal.utmTerm;
      data.adGroupId = cookieVal.adGroupId;
      data.keyword = cookieVal.keyword;
      data.utmDevice = cookieVal && cookieVal.utm_device ? cookieVal.utm_device : '';
    }
    /* --- */

    if (isAuthenticated) {
      // data.profileId = keycloak.subject;
      data.profileId = props.initialValues?.kcIdentityId || props?.userProfile?.kcIdentityId;;
      data.isAnonymousUser = false;
    }
    // console.log('Received values of form: ', values);
    if (values.upload && values.upload.fileList) {
      data.attachments = values.upload.fileList.map((fileobj) => {
        return fileobj.response;
      });
    }

    // console.log(data);
    setLoading(true);

    fetch(
      "https://ipapi.co/json/?key=JWzTw2TRf981G4oH1uZB5EwoM7iuNetMOB70dIhbnTAaO121To",
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((result) => {
        let { ip = "", country = "" } = result;
        data.fromIP = ip;
        data.ipCountry = country;
        sellerRFQCall(data);
      })
      .catch((err) => {
        apiError('onFinish', err, 'GET', 'SellerContact.js');
        logger("error", "Error from ipapi SellerContact: " + url + ": buyerId =>  "+props.initialValues?.kcIdentityId+ ': error => ' +err, process.env.NEXT_PUBLIC_LOGGER_URL);
        data.fromIP = "";
        data.ipCountry = "";
        sellerRFQCall(data);
      });
  };

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < moment().endOf("day");
  };

  // const children = [];
  // for (let i = 0; i < 5; i++) {
  //     children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
  // }

  // const displayErrors = errors => errors.map((err, i) => <Alert key={i} type="error" message={err.atStage} description={err.message} closable />)

  let assetUrl =
    process.env.NEXT_PUBLIC_REACT_APP_API_ASSETS_URL +
    "/assets?sourceService=forms";

  if (props.initialValues && props.initialValues.profileId) {
    assetUrl =
      process.env.NEXT_PUBLIC_REACT_APP_API_ASSETS_URL +
      "/assets?sourceService=forms&userId=" +
      props.initialValues.profileId;
  }

  return (
    <Row id="seller-contact-form">
      {/*<Col className="left-details" span={mediaMatch.matches ? 8 : 0}>
        <Row>
          <Col span={props.sellerDetails ? 24 : 0}>
            <div
              className="left-verified-seller"
              style={{ marginTop: "140px" }}
            >
              <p className="heading">Seller details</p>
              <div className="para">
                {/* <Avatar
                  size={40}
                  src={
                    props.sellerDetails &&
                    props.sellerDetails.brandLogo &&
                    props.sellerDetails.brandLogo.media &&
                    props.sellerDetails.brandLogo.media.mediaUrl &&
                    process.env.NEXT_PUBLIC_REACT_APP_ASSETS_FILE_URL +
                      props.sellerDetails.brandLogo.media.mediaUrl
                  }
                ></Avatar> }
                <span className="text-avatar">
                  {props.sellerDetails && props.sellerDetails.orgName}
                </span>
                {/* {props.sellerDetails &&
                  props.sellerDetails.verificationStatus &&
                  (props.sellerDetails.verificationStatus === "VERIFIED" ||
                    props.sellerDetails.verificationStatus ===
                      "REGISTERED") && ( */}
      {/* <span
                  style={{
                    color: "#d9bb7f",
                    verticalAlign: "middle",
                  }}
                >
                  <Icon component={certifiedIcon} className="certified-icon" />
                </span> */}
      {/* )} }
              </div>
              {/* <p className="para">
                <span className="label">Organisation type</span>
                <span className="text">
                  {props.sellerDetails && props.sellerDetails.orgType}
                </span>
              </p> }

              <Row className="para">
                <Col span={24}>
                  <span className="label">City</span>
                  {/* </Col> */}
      {/* <Col span={24} className="qa-txt-alg-lft"> }
                  <span className="text">
                    {props.sellerDetails && props.sellerDetails.city}
                  </span>
                </Col>
              </Row>

              <Row className="para">
                <Col span={24}>
                  <span className="label">Country</span>
                  {/* </Col> */}
      {/* <Col span={24} className="qa-txt-alg-lft"> }
                  <span className="text">
                    {props.sellerDetails && props.sellerDetails.country}
                  </span>
                </Col>
              </Row>

              {/* <p className="para">
                <span className="label">City</span>
                <span className="text">
                  {props.sellerDetails && props.sellerDetails.city}
                </span>
              </p>
              <p className="para">
                <span className="label">Country</span>
                <span className="text">
                  {props.sellerDetails && props.sellerDetails.country}
                </span>
              </p> }
            </div>
          </Col>
          <Col
            span={
              props.initialValues && props.initialValues.profileType ? 0 : 24
            }
          >
            <div className="left-verified-seller rfq-benefits-section">
              <p className="heading">
                Benefits of buying
                <br />
                on Qalara
              </p>
              <p className="para">
                1. A growing selection of artisanal, ecofriendly, organic,
                recycled, fair & social and sustainable products and suppliers
              </p>
              <p className="para">
                2. Verified producers and transparent practices
              </p>
              <p className="para">3. Small-to-mid sized buyer friendly terms</p>
              <p className="para">
                4. One stop sourcing platform from discovery to delivery
              </p>
              <p className="para">5. Secure digital commerce</p>
            </div>
          </Col>
          {/* <Col
            span={
              props.initialValues && props.initialValues.profileType ? 24 : 0
            }
          >
            <div className="left-verified-seller">
              <p className="heading">
                {props.initialValues &&
                props.initialValues.profileType &&
                props.initialValues.profileType === "SELLER"
                  ? "Seller"
                  : "Buyer"}{" "}
                details
              </p>
              <Row className="para">
                <Col span={12}>
                  <span className="label">First name</span>
                </Col>
                <Col span={12} className="qa-txt-alg-rgt">
                  <span className="text">
                    {props.initialValues && props.initialValues.firstName}
                  </span>
                  {props.initialValues &&
                    props.initialValues.verificationStatus &&
                    (props.initialValues.verificationStatus === "VERIFIED" ||
                      props.initialValues.verificationStatus ===
                        "REGISTERED") && (
                      <span
                        style={{
                          color: "#d9bb7f",
                          verticalAlign: "middle",
                          marginLeft: "3px",
                        }}
                      >
                        <Icon
                          component={certifiedIcon}
                          className="certified-icon"
                        />
                      </span>
                    )}
                </Col>
              </Row>

              <Row className="para">
                <Col span={12}>
                  <span className="label">Organisation type</span>
                </Col>
                <Col span={12} className="qa-txt-alg-rgt">
                  <span className="text">
                    {props.initialValues && props.initialValues.orgType}
                  </span>
                </Col>
              </Row>

              <Row className="para">
                <Col span={12}>
                  <span className="label">Country</span>
                </Col>
                <Col span={12} className="qa-txt-alg-rgt">
                  <span className="text">
                    {props.initialValues && props.initialValues.country}
                  </span>
                </Col>
              </Row>
            </div>
          </Col> }
        </Row>
      </Col>*/}
      <Col
        span={mediaMatch.matches ? 24 : 24}
        style={{ marginBottom: 0, padddinBoBottem: 0 }}
        className="register"
      >
        <Row justify="center">
          <Col span={20}>
     
            <p className="heading">Send order query</p>
            <p className="subheading"> SELLER ID - {props?.sellerDetails?.id.split("::")[2]}</p>
            <p className="paragraph">
            Use this form if you like this seller's portfolio but can't find what you are looking for, or you have a specific product
              requirement that you want the seller to develop!
            </p>
          </Col>
        </Row>
        {/* {errors.length > 0 && (
                    <div style={{ textAlign: 'left' }}>
                        {displayErrors(errors)}
                    </div>
                )} */}
        <Form
          form={form}
          name="seller_contact_form"
          initialValues={props.initialValues}
          onFinish={onFinish}
          scrollToFirstError
          autoComplete="dontshow"
        >
          <Row justify="center">
            <Col span={20}>
              {/* <span className="label-heading">
                What would you like help sourcing from India?
              </span>
              <br /> */}
              <span className="label-paragraph">
                Tell us briefly about your brand / business.*
              </span>
              <Form.Item
                name="aboutCompany"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    required: true,
                    message: "Please enter your requirement.",
                  },
                  {
                    min: 10,
                    max: 500,
                    message: "Please enter message within 10-500 characters",
                  },
                ]}
              >
                <Input.TextArea
                  onFocus={() => gtmFormFunction("about company")}
                  value={"value"}
                  // onChange={onChange}
                  // placeholder="Please input the details here"
                  autoSize={{ minRows: 2, maxRows: 4 }}
                  autoComplete="dontshow"
                  id={`aboutCompany_${generateRandomString()}`}
                />
              </Form.Item>

              {/* <Form.Item
                name="category"
                style={{ marginBottom: "1em" }}
                // label='I am looking for'
                rules={[
                  { required: true, message: "Please select a category." },
                ]}
              >
                <Select placeholder="Select category">
                  {typeOfCategories}
                </Select>
              </Form.Item> */}
              {/* <Form.Item
                        name="greeting"
                        rules={[
                            {
                                type: 'string',
                                message: 'The input is not valid message!',
                            },
                            {
                                required: true,
                                message: 'Please input your message!',
                            },
                            { min: 30, max: 150, message: 'Message length should be 30-150 characters!' }
                        ]}
                    >
                        <Input.TextArea
                            value={"value"}
// onChange={onChange}
                            placeholder="Greeting"
                            autoSize={{ minRows: 1, maxRows: 5 }} />
                    </Form.Item> */}
              <span className="label-paragraph">
                Please share product details and customisation requirements.*
              </span>
              <Form.Item
                name="requirementDetails"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    required: true,
                    message: "Please enter your requirement.",
                  },
                  {
                    min: 2,
                    max: 500,
                    message: "Please enter message within 2-500 characters.",
                  },
                ]}
              >
                <Input.TextArea
                  onFocus={() => gtmFormFunction("requirement details")}
                  value={"value"}
                  // onChange={onChange}
                  // placeholder="Please input the details here"
                  autoSize={{ minRows: 2, maxRows: 4 }}
                  autoComplete="dontshow"
                  id={`requirementDetails_${generateRandomString()}`}
                />
              </Form.Item>
              {/* <Form.Item
                        name="requirement"
                        rules={[{ required: true, message: 'Please input requirements!' },
                        { min: 3, max: 30, message: 'Length should be 3-30 characters!' }]}
                    >
                        <Input
// prefix={<ShopOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="What do you need from the seller?"
                        />
                    </Form.Item> */}
              {/* <Form.Item
                        name="requirement"
                        rules={[{ required: true, message: 'Please select the item.' }]}
                    >
                        <Select style={{ flex: '0' }} showSearch placeholder="What do you need from the seller?">
                            {children}
                        </Select>
                    </Form.Item> */}

              <div className="label-paragraph">Product category</div>
              <Form.Item
                name="productCategory"
                rules={[
                  { required: true, message: "Please select product category." },
                ]}
              >
               <Select
               mode="multiple"
               showArrow
               autoComplete="dontshow"
               value={selectedProductOption}
               placeholder="Select product category"
               onChange={setSelectedProductOption}
               className="select-multiple-product"
               >
                {productCategories && productCategories?.map((category) => {
                  return (
                    <Select.Option value={category.name}>{category.name}</Select.Option>
                  )
                })}
               </Select>
              </Form.Item>
              <div className="label-paragraph">If you have any customization requirements, please select them from the options below.</div>
              <Form.Item
                name="customizationRequirements"
                rules={[
                  { required: true, message: "Please select customization requirements." },
                ]}
              >
               <Select
               mode="multiple"
               showArrow
               autoComplete="dontshow"
               value={selectedOption}
               placeholder="Select customization type"
               onChange={setSelectedOption}
               className="select-multiple-product"
               >
                <Select.Option  disabled={selectedOption?.includes("other")} value="branding">Branding</Select.Option>
                <Select.Option disabled={selectedOption?.includes("other")} value="color">Color</Select.Option>
                <Select.Option disabled={selectedOption?.includes("other")} value="size">Size</Select.Option>
                <Select.Option disabled={selectedOption?.includes("other")} value="design">Design</Select.Option>
                <Select.Option disabled={selectedOption?.includes("other")} value="material">Material</Select.Option>
                <Select.Option disabled={!selectedOption?.includes("other") && (selectedOption?.length !== 0)} value="other">Other</Select.Option>
               </Select>
              </Form.Item>
              {selectedOption?.includes('other') ?
              <Form.Item
                name="additionalRequirement"
                rules={[
                  {
                    required: true,
                    message: "Please enter your requirement.",
                  },
                  {
                    min: 10,
                    max: 500,
                    message: "Please enter message within 10-500 characters.",
                  },
                ]}
              >
                <Input.TextArea
                  onFocus={() => gtmFormFunction("additional requirement")}
                  value={"value"}
                  autoSize={{ minRows: 4, maxRows: 6 }}
                  autoComplete="dontshow"
                  placeholder="Specify any additional needs here"
                  onChange={(e) => {setSelectedOther(e.target.value)}}
                />
              </Form.Item> : ""}      
              <span className="label-paragraph">
                Attach reference images of designs, if available.
              </span>

              <Form.Item
                name="upload"
                style={{ marginBottom: "1em" }}
                // rules={[{ required: true, message: 'Please upload atleast one item.' }]}
                // getValueFromEvent={normFile}
                extra={
                  <span className="paragraph">
                    Max Size per attachment: 2Mb
                  </span>
                }
              >
                <Upload
                  name="files"
                  listType="picture-card"
                  fileList={fileList}
                  action={assetUrl}
                  headers={{
                    Authorization: "Bearer " + props.token,
                  }}
                  // className="avatar-uploader"
                  beforeUpload={beforeUpload}
                  onPreview={onPreview}
                  onChange={handleChange}
                  multiple
                >
                  {fileList.length >= 10 ? null : <PlusOutlined />}
                </Upload>
              </Form.Item>
              <span className="label-paragraph">
                Please give an indication of quantities required per product*
              </span>
              <Form.Item
                name="quantity"
                style={{ marginBottom: "0" }}
                rules={[
                  // {
                  //   type: "string",
                  //   message: "The input is not valid!",
                  // },
                  {
                    required: true,
                    message: "Please enter target quantity.",
                  },
                  {
                    min: 1,
                    max: 50,
                    message: "Length should be 1-50 characters!",
                  },
                ]}
              >
                {/* <Input
                  onFocus={() => gtmFormFunction("quantity")}
                  autoComplete="dontshow"
                  id={`quantity_${generateRandomString()}`}
                  // style={{
                  //     width: '100%',
                  // }}
                  // min={1}
                  // max={1000}
                  // placeholder="Quantity"
                /> */}

                <Select 
                 placeholder="Select quantity"
                 onFocus={() => gtmFormFunction("quantity")}
                 autoComplete="dontshow"
                 showSearch
                 getPopupContainer={(trigger) => trigger.parentElement}
                 id={`quantity_${generateRandomString()}`}>
                  <Option value="50-100perSKU">50 - 100 per SKU</Option>
                  <Option value='100-300perSKU'>100 - 300 per SKU </Option>
                  <Option value='300-500perSKU'>300 - 500 per SKU</Option>
                  <Option value='500-1000perSKU'>500 - 1000 per SKU</Option>
                  <Option value='1000-5000perSKU'>1000 - 5000 per SKU</Option>
                  <Option value='5000+perSKU'>Above 5000 per SKU</Option>

                </Select>
              </Form.Item>
              <div><span className="paragraph">
                For lower quantities, we recommend you select products from our existing catalog
                  </span></div><br />
              {/* <span className="label-paragraph">
                What is your target cost (USD)?
              </span>
              <Form.Item
                name="pricePerItem"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    type: "string",
                    message: "The input is not valid!",
                  },
                  {
                    min: 1,
                    max: 50,
                    message: "Length should be 1-50 characters!",
                  },
                ]}
              >
                <Input
                // style={{
                //     width: '100%',
                // }}
                // min={1}
                // max={1000000}
                // placeholder="Target price per piece (In USD)"
                />
              </Form.Item>
              <span className="label-paragraph">
                What is your required delivery date?
              </span>
              <Form.Item
                name="deliveryDate"
                placeholder=""
                style={{ marginBottom: "1em" }}
              >
                <DatePicker
                  disabledDate={disabledDate}
                  style={{ width: "100%" }}
                  // placeholderplaceholder="Target delivery date"
                />
              </Form.Item> */}
              <span className="label-paragraph">Destination Country*</span>
              <Form.Item
                name="destinationCountry"
                style={{ marginBottom: "1em" }}
                rules={[
                  { required: true, message: "Please select your country." },
                ]}
              >
                <Select
                  placeholder="Select country"
                  showSearch
                  getPopupContainer={(trigger) => trigger.parentElement}
                  autoComplete="dontshow"
                  id={`destinationCountry_${generateRandomString()}`}
                  filterOption={(input, option) =>
                    option.props.value
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0 ||
                    option.props.label
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {countryList}
                </Select>
              </Form.Item>
              <span className="label-paragraph">Delivery location type</span>
              <Form.Item
                name="deliverylocationType"
                style={{ marginBottom: "1em" }}
                // rules={[
                //   {
                //     required: true,
                //     message: "Please select your delivery location type.",
                //   },
                // ]}
              >
                <Select
                  placeholder="Select location type"
                  showSearch
                  onFocus={() => gtmFormFunction("location type")}
                  autoComplete="dontshow"
                  id={`deliverylocationType_${generateRandomString()}`}
                >
                  <Option value="home">Home</Option>
                  <Option value="store">Store</Option>
                  <Option value="office">Office</Option>
                  <Option value="warehouse">Warehouse</Option>
                  <Option value="amazonWarehouse">Amazon Warehouse</Option>
                  <Option value="others">Others</Option>
                  );
                </Select>
              </Form.Item>
              <span className="label-paragraph">Destination Pin/ Postal/ Zip Code*</span>
              <Form.Item
                name="zipcode"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    required: true,
                    message: "Please enter your zipcode.",
                    whitespace: true,
                  },
                ]}
              >
                <Input
                  onFocus={() => gtmFormFunction("zip code")}
                  autoComplete="dontshow"
                  id={`zipcode_${generateRandomString()}`}
                />
              </Form.Item>
              {/* <span className="label-paragraph">Destination City, State*</span>
              <Form.Item
                name="destinationCity"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    required: true,
                    message: "Please input State & City name!",
                  },
                  {
                    min: 3,
                    max: 50,
                    message: "Length should be 3-50 characters!",
                  },
                ]}
              >
                <Input
// placeholder="State, City"
                />
              </Form.Item> */}
              {/* <br /> */}
              <div className="label-heading qa-lh">
                Please share your details so we can respond:
              </div>
              <div
                className="paragraph info-safe"
                style={{
                  margin: "5px 0px 12px",
                  lineHeight: "100%",
                  textAlign: "left",
                }}
              >
                Your information is safe with us.
              </div>
              {/* <p style={{ fontWeight: 'bold', fontSize: '15px', marginBottom: '0.5em' }}>From,</p> */}
              <span className="label-paragraph">Your name*</span>
              <Form.Item
                name="requesterName"
                style={{ marginBottom: "1em" }}
                rules={[
                  { required: true, message: "Please enter your name." },
                  {
                    min: 3,
                    max: 50,
                    message: "Length should be 3-50 characters!",
                  },
                ]}
              >
                <Input
                  onFocus={() => gtmFormFunction("requester name")}
                  autoComplete="dontshow"
                  id={`requestorName_${generateRandomString()}`}
                  // placeholder="Your Name"
                />
              </Form.Item>
              <span className="label-paragraph">Company name*</span>
              <Form.Item
                name="companyName"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    required: true,
                    message: "Please enter your company name.",
                  },
                  {
                    min: 3,
                    max: 50,
                    message: "Length should be 3-50 characters!",
                  },
                ]}
              >
                <Input
                  onFocus={() => gtmFormFunction("company name")}
                  autoComplete="dontshow"
                  id={`companyName_${generateRandomString()}`}
                  // placeholder="Company Name"
                />
              </Form.Item>
              <span className="label-paragraph">Email address*</span>
              <Form.Item
                name="emailId"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    type: "email",
                    message: "Please enter a correct email address.",
                  },
                  {
                    required: true,
                    message: "Please enter your email address.",
                  },
                ]}
              >
                <Input
                  onFocus={() => gtmFormFunction("email")}
                  autoComplete="dontshow"
                  id={`emailId_${generateRandomString()}`}
                  // placeholder="E-mail ID"
                />
              </Form.Item>

              <span className="label-paragraph">Phone number</span>
              <Form.Item
                name="mobileNo"
                style={{ marginBottom: "1em" }}
                rules={[
                  // {
                  //     required: true,
                  //     message: 'Please input contact number!',
                  // },
                  {
                    pattern: new RegExp("^[0-9]{6,15}$"),
                    message: "Wrong format!",
                  },
                ]}
              >
                <Input
                  onFocus={() => gtmFormFunction("mobile number")}
                  autoComplete="dontshow"
                  id={`mobileNo_${generateRandomString()}`}
                  // placeholder="Phone Number"
                />
              </Form.Item>

              <span className="label-paragraph">
                Preferred currency for quotation
              </span>
              <Form.Item
                name="preferedCurrency"
                style={{ marginBottom: "1em" }}
                rules={[
                  {
                    required: true,
                    message:
                      "Please select your preferred currency for quotation.",
                  },
                ]}
              >
                <Select
                  placeholder="Select preferred currency"
                  showSearch
                  onFocus={() => gtmFormFunction("currency")}
                  getPopupContainer={(trigger) => trigger.parentElement}
                  autoComplete="dontshow"
                  id={`preferedCurrency_${generateRandomString()}`}
                >
                  <Option value="USD">USD</Option>
                  <Option value="AUD">AUD</Option>
                  <Option value="EUR">EUR</Option>
                  <Option value="GBP">GBP</Option>
                  );
                </Select>
              </Form.Item>

              {/* <Form.Item
                        name="liveDemoInterest"
                        valuePropName="checked"
                        style={{ marginBottom: '0.2em' }}
                    >
                        <Checkbox>
                            I am interested in live demo with seller.
                        </Checkbox>
                    </Form.Item> */}
              {/* <Form.Item
                name="agreement"
                style={{ marginBottom: "1em" }}
                valuePropName="checked"
                rules={[
                  {
                    validator: (_, value) =>
                      value
                        ? Promise.resolve()
                        : Promise.reject("Please accept the agreement."),
                  },
                ]}
              >
                <Checkbox className="check-box-tnc">
                  Standard{" "}
                  <Link className="link-text" href="/TermsOfUse">
                    <a target="_blank" className="link-text">
                      T&C
                    </a>
                  </Link>{" "}
                  apply.*
                </Checkbox>
              </Form.Item> */}
              {!(props.initialValues && props.initialValues.profileId) && (
                <Form.Item
                  className="agreement"
                  name="recaptcha"
                  style={{ marginBottom: "1em" }}
                  valuePropName="recaptcha"
                  rules={[
                    {
                      validator: (_, value) =>
                        value
                          ? Promise.resolve()
                          : Promise.reject("Please accept the recaptcha."),
                    },
                  ]}
                >
                  <ReCAPTCHA
                    sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                    ref={recaptchaRef}
                    onChange={onChange}
                  />
                </Form.Item>
              )}
                {/* <Form.Item name="mobileNo">
                  <Checkbox 
                   onChange={(e) => {
                    let { checked = "" } = e.target || {};
                     setWhatsApp(checked);
                    }}   
                    checked={whatsApp} 
                  > </Checkbox>
                    <div className="whatsapp-consent-cart-wrapper input-wrapper">
                      <span className="whatsapp-consent-cart qa-fs-12 qa-fw-b">Receive updates regarding your quote request on <WhatsAppOutlined /> WhatsApp</span><br />
                      <span className="user-phone-number-text qa-fs-12">Phone number</span>
                      <Input
                        className='user-mobile-number qa-fs-10'
                        type="text"
                        disabled
                        autoComplete='dontshow'
                        value={whatsAppNumber}
                        // onChange={updateWhatsappNumber}
                      />
                    </div>
                </Form.Item> */}
            </Col>
          </Row>
          <Form.Item style={{ margin: "0" , textAlign : "center"}}>
            <Button
              type="primary"
              loading={loading}
              disabled={loading}
              htmlType="submit"
              className="submit-button"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
};

export default SellerContact;